import { useState, useEffect } from 'react';

export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);


  console.log({function: "useDebounce", value})

  useEffect(() => {
    // Устанавливаем таймер на обновление значения
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Очищаем таймер, если пользователь нажал клавишу до истечения delay
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]); // Перезапускается при каждом изменении текста

  return debouncedValue;
}
